// extracted by mini-css-extract-plugin
export default {"button":"RegisterLink_button__IbdzR","labelSize":"RegisterLink_labelSize__Ii2e+"};